/* eslint-disable react-hooks/rules-of-hooks */
import React, { useEffect, useState } from 'react'

import offIcon from '../../../../assets/svg/offIcon.svg'
import { useForm } from "react-hook-form"

import 'react-modern-calendar-datepicker/lib/DatePicker.css'
import DatePicker from '@taak/react-modern-calendar-datepicker'

import ReactSearchBox from "react-search-box"

import Menu from '../../../../components/CustomerClub/Menu'

import { notify } from '../../../../components/Toast'
import { ToastContainer } from 'react-toastify'

import { deleteItem, get, put } from '../../../../services/http'

import { useNavigate, useParams } from 'react-router-dom'

function index() {
  document.title = 'جزئیات کدتخفیف'

  const navigate = useNavigate()
  const { id } = useParams()

  const [modal, setModal] = useState(false)
  const [cover, setCover] = useState(false)

  const { register, handleSubmit, reset } = useForm()

  const [selectedDay, setSelectedDay] = useState('')
  const [selectedDayShow, setSelectedDayShow] = useState('')
  const [typePrice, setTypePrice] = useState('static')
  const [basketLimit, setBasketLimit] = useState('no')
  const [limitCount, setLimitCount] = useState('no')
  const [limitUser, setLimitUser] = useState('no')
  const [userId, setUserId] = useState('')
  const [users, setUser] = useState([])

  const token = localStorage.getItem('token')

  useEffect(() => {
    get(`/api/admin/users/all?token=${token}`)
      .then(response => {
        const data = []
        response.data.data.map((item) => {
          return data.push({ 
            key: item.name,
            value: item.name,
            id: item._id,
            phoneNumber: item.phoneNumber
          })
        })
        setUser(data)

      get(`/api/admin/ccoffcode/${id}?token=${token}`)
        .then(response => {
          console.log(response)
          let defaultValues = {}
          defaultValues.codeName = response.data.data[0].code
          setTypePrice(response.data.data[0].priceType)
          if (response.data.data[0].priceType === 'percent') {
            defaultValues.codePercent = response.data.data[0].codePercent
          } else {
            defaultValues.codePrice = response.data.data[0].codePrice
          }

          setSelectedDay(response.data.data[0].enDate)
          setSelectedDayShow(`${response.data.data[0].enDate.year}/${response.data.data[0].enDate.month}/${response.data.data[0].enDate.day}`)

          setBasketLimit(response.data.data[0].limitBasket)
          defaultValues.limitBasketPrice = response.data.data[0].limitBasketPrice
          setLimitCount(response.data.data[0].limitCount)
          defaultValues.limitCountValue = response.data.data[0].limitCountValue
          setLimitUser(response.data.data[0].limitUser)
          
          defaultValues.percent = response.data.data[0].percent
          reset({ ...defaultValues })
        })
    })
    .catch(error => {
      notify('error', 'دریافت اطلاعات با خطا مواجه شد')
    })
  }, [id, reset, token])

  const onSubmit = (data, e) => {
    e.preventDefault()

    if (selectedDay !== '') {
      if (data.limitUser === 'no') {
        put(`/api/admin/ccoffcode/${id}?token=${token}`, {
          enDate: selectedDay,
          code: data.codeName,
          priceType: data.priceType,
          codePercent: parseInt(data.codePercent === '' ? 0 : data.codePercent),
          codePrice: parseInt(data.codePrice === '' ? 0 : data.codePrice),
          limitBasket: data.limitBasket,
          limitBasketPrice: parseInt(data.limitBasketPrice === '' ? 0 : data.limitBasketPrice),
          limitCount: data.limitCount,
          limitCountValue: parseInt(data.limitCountValue === '' ? 0 : data.limitCountValue),
          limitUser: data.limitUser,
          id: ''
        }).then(response => {
          notify('success', response.data.messageFa)
          setTimeout(() => {
            navigate('/cc/offs')
          }, 2000)
        }).catch(error => {
          if (error.response.data.messageFa === "این کد تخفیف موجود می باشد") {
            return notify('error', 'کد تخفیف موجود می باشد')
          }
          notify('error', 'خطا در ارسال اطلاعات')
        })
      } else if (data.limitUser === 'limit' && userId.length >= 2) {
        put(`/api/admin/ccoffcode/${id}?token=${token}`, {
          enDate: selectedDay,
          code: data.codeName,
          priceType: data.priceType,
          codePercent: parseInt(data.codePercent === '' ? 0 : data.codePercent),
          codePrice: parseInt(data.codePrice === '' ? 0 : data.codePrice),
          limitBasket: data.limitBasket,
          limitBasketPrice: parseInt(data.limitBasketPrice === '' ? 0 : data.limitBasketPrice),
          limitCount: data.limitCount,
          limitCountValue: parseInt(data.limitCountValue === '' ? 0 : data.limitCountValue),
          limitUser: data.limitUser,
          id: userId
        }).then(response => {
          notify('success', response.data.messageFa)
          setTimeout(() => {
            navigate('/cc/offs')
          }, 2000)
        }).catch(error => {
          if (error.response.data.messageFa === "این کد تخفیف موجود می باشد") {
            return notify('error', 'کد تخفیف موجود می باشد')
          }
          notify('error', 'خطا در ارسال اطلاعات')
        })
      } else {
        notify('error', 'لطفاً کاربر مورد نظر را انتخاب کنید')
      }
    } else {
      notify('error', 'لطفاً تاریخ اتمام را انتخاب کنید')
    }
  }

  const deleteHandler = (e) => {
    deleteItem(`/api/admin/ccoffcode/${id}?token=${token}`)
      .then(response => {
        setCover(false)
        setModal(false)
        notify('success', response.data.messageFa)
        setTimeout(() => {
          navigate('/cc/offs')
        }, 2000)
      })
      .catch(error => {
        if (error) {
          notify('error', error)
        }
        notify('error', 'خطا در ارسال اطلاعات')
      })
  }

  return (
    <main id='panel'>
      <div className="cover" style={{ display: cover? '': 'none' }}>
      </div>
      <div className='deleteModal' style={{ display: modal? '': 'none' }}>
        <div className="textDeleteModal">
          آیا میخواهید کد تخفیف مورد نظر حذف شود؟
        </div>
        <hr />
        <div className="buttons">
          <button onClick={deleteHandler}>حذف شود</button>
          <button onClick={e => {
            setCover(false)
            setModal(false)
          }}>انصراف</button>
        </div>
      </div>
      <ToastContainer rtl />
      <Menu page={'offs'} badgeCountDashboard={0} badgeCountOrder={0} />
      <article className='panelBody'>
        <section className='panelContent'>
          <div className='title'>
            <div className="right">
              <div className='icon'>
                <img src={offIcon} alt='resturantIcon' />
              </div>
              <div className='text'>
                کد تخفیف
              </div>
            </div>
            <div className='left'>
              <div>
                <button onClick={e => { 
                  setCover(true)
                  setModal(true) }} style={{ backgroundColor: '#ff6666' }} className='createButton' type='submit'>حذف کد تخفیف</button>
              </div>
            </div>
          </div>

          <form className='form' onSubmit={handleSubmit(onSubmit)}>
            <div className='title'>
              * برای ایجاد کد تخفیف لطفا تمامی فیلد های مشخص شده را پر کنید.
            </div>
            <div className='lineTitle'>
              <hr />
              اطلاعات کد تخفیف‌
              <hr />
            </div>
            <div className='row'>
              <div className='column'>
                <label htmlFor='offCodeName'>نام کد تخفیف * :</label>
                <input id='offCodeName' {...register("codeName", { required: true, minLength: 3 })} className='ltrdirection' type='text' placeholder='start' />
                <small id='offCodeNameAlert'>نام کد تخفیف باید وارد شود</small>
              </div>
              <div className='column'>
                <label htmlFor='offCodeName'>نوع کد تخفیف * :</label>
                <select id='resturantName' {...register("priceType", { 
                  onChange: (e) => {
                    if (e.target.value === 'static') {
                      setTypePrice('static')
                    } else if (e.target.value === 'percent') {
                      setTypePrice('percent')
                    }
                  },
                  required: true })}>
                  <option id='none'>انتخاب کنید</option>
                  <option selected={typePrice === 'static'} value="static">مبلغ ثابت</option>
                  <option selected={typePrice === 'percent'} value="percent">درصدی</option>
                </select>
                <small id='offCodeNameAlert'>نوع کد تخفیف باید وارد شود</small>
              </div>
            </div>
            <div className='row'>
              <div className='column'>
                <label htmlFor='offCodeDate'>تاریخ اتمام * {selectedDayShow} :</label>
                <small id='offCodeDateAlert'>اولویت باید وارد شود</small>
                <DatePicker
                  value={selectedDay}
                  onChange={setSelectedDay}
                  shouldHighlightWeekends
                  locale="fa" // add this
                />
              </div>
              <div className='column' style={typePrice === 'static' ? { display: '' } : { display : 'none' }}>
                <label htmlFor='offCodeName'>مبلغ تخفیف * :</label>
                <input id='offCodeName' {...register("codePrice", { required: false, minLength: 1 })} className='ltrdirection' type='number' placeholder='...' />
                <small id='offCodeNameAlert'>نام کد تخفیف باید وارد شود</small>
              </div>
              <div className='column' style={typePrice === 'static' ? { display: 'none' } : { display : '' }}>
                <label htmlFor='offCodeName'>درصد تخفیف * :</label>
                <input id='offCodeName' {...register("codePercent", { required: false, minLength: 1 })} className='ltrdirection' type='number' placeholder='...' />
                <small id='offCodeNameAlert'>نام کد تخفیف باید وارد شود</small>
              </div>
            </div>
            <div className='lineTitle'>
              <hr />
              شرایط سبد خرید
              <hr />
            </div>
            <div className="row">
              <div className='column'>
                <label htmlFor='offCodeName'>محدودیت * :</label>
                <select id='resturantName' {...register("limitBasket", { 
                  onChange: (e) => {
                    if (e.target.value === 'no') {
                      setBasketLimit('no')
                    } else if (e.target.value === 'limit') {
                      setBasketLimit('limit')
                    }
                  },
                  required: true })}>
                  <option selected={basketLimit === 'no'} value="no">بدون محدودیت</option>
                  <option selected={basketLimit === 'limit'} value="limit">دارای محدودیت</option>
                </select>
                <small id='offCodeNameAlert'>نوع کد تخفیف باید وارد شود</small>
              </div>
              <div className='column' style={basketLimit === 'limit' ? { display: '' } : { display : 'none' }}>
                <label htmlFor='offCodeName'>حداقل مبلغ سبد خرید* :</label>
                <input id='offCodeName' {...register("limitBasketPrice", { required: false, minLength: 1 })} className='ltrdirection' type='number' placeholder='...' />
                <small id='offCodeNameAlert'>نام کد تخفیف باید وارد شود</small>
              </div>
            </div>
            <div className='lineTitle'>
              <hr />
              محدودیت استفاده
              <hr />
            </div>
            <div className="row">
              <div className='column'>
                <label htmlFor='offCodeName'>محدودیت * :</label>
                <select id='resturantName' {...register("limitCount", { 
                  onChange: (e) => {
                    if (e.target.value === 'no') {
                      setLimitCount('no')
                    } else if (e.target.value === 'limit') {
                      setLimitCount('limit')
                    }
                  },
                  required: true })}>
                  <option selected={limitCount === 'no'} value="no">بدون محدودیت</option>
                  <option selected={limitCount === 'limit'} value="limit">دارای محدودیت</option>
                </select>
                <small id='offCodeNameAlert'>نوع کد تخفیف باید وارد شود</small>
              </div>
              <div className='column' style={limitCount === 'limit' ? { display: '' } : { display : 'none' }}>
                <label htmlFor='offCodeName'>حداکثر تعداد سفارش * :</label>
                <input id='offCodeName' {...register("limitCountValue", { required: false, minLength: 1 })} className='ltrdirection' type='number' placeholder='...' />
                <small id='offCodeNameAlert'>نام کد تخفیف باید وارد شود</small>
              </div>
            </div>
            <div className='lineTitle'>
              <hr />
              محدودیت کاربر
              <hr />
            </div>
            <div className="row">
              <div className='column'>
                <label htmlFor='offCodeName'>محدودیت * :</label>
                <select id='resturantName' {...register("limitUser", { 
                  onChange: (e) => {
                    if (e.target.value === 'no') {
                      setLimitUser('no')
                    } else if (e.target.value === 'limit') {
                      setLimitUser('limit')
                    }
                  },
                  required: true })}>
                  <option selected={limitUser === 'no'} value="no">بدون محدودیت</option>
                  <option selected={limitUser === 'limit'} value="limit">دارای محدودیت</option>
                </select>
                <small id='offCodeNameAlert'>نوع کد تخفیف باید وارد شود</small>
              </div>
              <div className='column' style={limitUser === 'limit' ? { display: '' } : { display : 'none' }}>
                <label htmlFor='offCodeName'>نام کاربر * :</label>
                <ReactSearchBox
                  placeholder="نام کاربر"
                  value="Doe"
                  data={users}
                  callback={(record) => console.log('')}
                  onSelect={(record) => setUserId(record.item.id)}
                />
                <small id='offCodeNameAlert'>نام کد تخفیف باید وارد شود</small>
              </div>
            </div>
            <button className='createButton'>آپدیت کد تخفیف</button>
          </form>

          <div className="copyright">
            © تمامی حقوق برای <a href='https://ibills.ir'>ibills</a> محفوظ است. طراحی و توسعه توسط <a href='https://ham-team.ir'>هم تیم</a>
          </div>
        </section>
      </article>
    </main>
  )
}

export default index